import { render, staticRenderFns } from "./speech-generation-panel.vue?vue&type=template&id=943e5d5c&scoped=true"
import script from "./speech-generation-panel.vue?vue&type=script&lang=ts"
export * from "./speech-generation-panel.vue?vue&type=script&lang=ts"
import style0 from "./speech-generation-panel.vue?vue&type=style&index=0&id=943e5d5c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "943e5d5c",
  null
  
)

export default component.exports